import { MAX_RESULTS } from '../../helpers/constants';
export const getPaginationCount = (totalCount, pageSize) => {
    const pageLimit = Math.floor(MAX_RESULTS / pageSize);
    const count = Math.ceil(Math.min(Math.min(totalCount, MAX_RESULTS) / pageSize, pageLimit));
    return count;
};
